// @dynamic-i18n-keys
//   actionbar.regularView
//   actionbar.regularView.disabled
//   actionbar.theaterView
//   actionbar.theaterView.disabled
import React from 'react';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import ActionBarIcon from '../../_partials/ActionBarIcon';
import { useDeviationViewContext } from '../../../Context';
import DefaultViewIcon from '@wix/da-ds/pkg/Icons/DefaultView';
import TheaterViewIcon from '@wix/da-ds/pkg/Icons/TheaterView';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import ActionBarButton from '../../_partials/items/ActionBarButton';

export interface Props {
  deviation: PapiDeviation;
  isTheaterForced: boolean;
  onClick: (deviation: PapiDeviation) => void;
}

export const TheaterButton: React.FC<React.PropsWithChildren<Props>> = ({
  isTheaterForced,
  deviation,
  onClick,
}) => {
  const { t } = useTranslation();
  const { isTheater } = useDeviationViewContext();

  return (
    <ActionBarItemWrapper
      tooltip={t(
        `actionbar.${isTheater ? 'regular' : 'theater'}View${
          isTheaterForced ? '.disabled' : ''
        }`
      )}
    >
      <ActionBarButton
        onClick={() => onClick(deviation)}
        disabled={isTheaterForced}
      >
        <ActionBarIcon icon={isTheater ? DefaultViewIcon : TheaterViewIcon} />
      </ActionBarButton>
    </ActionBarItemWrapper>
  );
};
TheaterButton.displayName = 'TheaterButton';

export default TheaterButton;
